import { render, staticRenderFns } from "./editAndListBlogToExtract.vue?vue&type=template&id=6ca81148&"
import script from "./editAndListBlogToExtract.vue?vue&type=script&lang=js&"
export * from "./editAndListBlogToExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports